var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('ul',{staticClass:"stages_list"},_vm._l((_vm.items),function(s){return _c('li',{class:{ 'active' : s.id == _vm.value, 'editable': _vm.editable },on:{"click":function($event){return _vm.changeState(s)}}},[_c('span',[_vm._v(_vm._s(s.nazev))])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca4df39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StavObjednavky.vue
// module id = null
// module chunks = 